import { isFeatureEnabled } from 'owa-feature-flags';

export function isCollabSpaceReadEnabled(): boolean {
    return (
        // Functionality restricted to Teams client as per EU settlement
        // cal-disable-meeting-notes will be rolled out to "true" for everything except Teams
        !isFeatureEnabled('cal-disable-meeting-notes') &&
        (isFeatureEnabled('cal-cmp-fluidCollaborativeSpace') ||
            isFeatureEnabled('cal-fluid-collabSpaceRead'))
    );
}
